type DataTablePrimary = {
  caption?: string;
  header_1: string;
  header_2: string;
  header_3?: string;
  header_4?: string;
};

type DataTableRow = {
  cell_1: string;
  cell_2: string;
  cell_3?: string;
  cell_4?: string;
};

export function DataTableSlice({
  primary,
  items,
}: {
  primary: DataTablePrimary;
  items: DataTableRow[];
}) {
  const hasCol3 = Boolean(primary.header_3);
  const hasCol4 = Boolean(primary.header_4);

  return (
    <div className="my-md overflow-x-auto">
      <table className="w-full border-collapse">
        {primary.caption && (
          <caption className="pb-xs text-left font-semibold">
            {primary.caption}
          </caption>
        )}
        <thead>
          <tr>
            <th className="border-gray bg-light-gray p-xs lg:p-sm border border-solid text-left align-top font-semibold">
              {primary.header_1}
            </th>
            <th className="border-gray bg-light-gray p-xs lg:p-sm border border-solid text-left align-top font-semibold">
              {primary.header_2}
            </th>
            {hasCol3 && (
              <th className="border-gray bg-light-gray p-xs lg:p-sm border border-solid text-left align-top font-semibold">
                {primary.header_3}
              </th>
            )}
            {hasCol4 && (
              <th className="border-gray bg-light-gray p-xs lg:p-sm border border-solid text-left align-top font-semibold">
                {primary.header_4}
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {items.map((row, i) => (
            <tr key={i}>
              <td className="border-gray p-xs lg:p-sm border border-solid text-left align-top">
                {row.cell_1}
              </td>
              <td className="border-gray p-xs lg:p-sm border border-solid text-left align-top">
                {row.cell_2}
              </td>
              {hasCol3 && (
                <td className="border-gray p-xs lg:p-sm border border-solid text-left align-top">
                  {row.cell_3}
                </td>
              )}
              {hasCol4 && (
                <td className="border-gray p-xs lg:p-sm border border-solid text-left align-top">
                  {row.cell_4}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
